import React from "react";
import Utils from "../utils/utils";
import AdminProfileComp from "../components/AdminProfileComp";
import StudentProfileComp from "../components/StudentProfile/StudentProfileComp";

const Profile = () => {
  const role = Utils.UserRole;
  const Admin = role ? role.toLowerCase() === "admin" : null;

  return (
    <div
      className="shadow-none p-4 overflow-y-auto h-[calc(100vh-65px)]"
      bkl="Profile"
    >
      {Admin ? <AdminProfileComp /> : <StudentProfileComp />}
    </div>
  );
};

export default Profile;
